import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import util from '@utils/util';
// import webLogin from '@utils/weblogin';
import BlurImage from '../../blur-image';
// import Loading from '../../loading';
import LiveCompleted from '../../live-completed';
import liveRoomIcons from './LiveRoomIcons';
var VideoPlayer = window['video-player'].VideoPlayer;

/**
 * 播放器基础事件 比如开始 暂停
 */
var UIMediaEvent = {
  ABORT: 'abort',
  CAN_PLAY: 'canplay',
  CAN_PLAY_THROUGH: 'canplaythrough',
  DURATION_CHANGE: 'durationchange',
  EMPTIED: 'emptied',
  ENDED: 'ended',
  ERROR: 'error',
  LOADED_DATA: 'loadeddata',
  LOADED_METADATA: 'loadedmetadata',
  LOAD_START: 'loadstart',
  PAUSE: 'pause',
  PLAY: 'play',
  PLAYING: 'playing',
  PROGRESS: 'progress',
  RATE_CHANGE: 'ratechange',
  SEEKED: 'seeked',
  SEEKING: 'seeking',
  STALLED: 'stalled',
  SUSPEND: 'suspend',
  TIME_UPDATE: 'timeupdate',
  VOLUME_CHANGE: 'volumechange',
  WAITING: 'waiting'
};
/**
 * 播放器事件 比如刷新，下一条等
 */
var UIMeidaPlayerEvent = {
  REFRESH: 'refresh',
  NEXT: 'next',
  POPUP: 'popup',
  UNPOPUP: 'unpopup',
  CLOSE: 'close',
  DOWNLOADER_CHANGE: 'downloaderchange'
};
var DEFAULT_OPTIONS = {
  autoplay: true,
  anywayAutoplay: true
};
var DEFAULT_MEDIA_SOURCES_OPTIONS = {
  isPrimary: true,
  identifier: 0
};
export default {
  name: 'mVideoPlayer',
  props: {
    authentication: Object,
    completed: Boolean,
    deleted: Boolean,
    showLoading: Boolean,
    src: [String, Array],
    poster: String,
    options: Object,
    downloader: Object,
    vid: String,
    hostid: String,
    isHandLiveroom: {
      default: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      isWaiting: false,
      player: null,
      loadingElement: null,
      desktopController: null,
      isShowIcons: false
    };
  },
  components: {
    'blur-image': BlurImage,
    // loading: Loading,
    'live-completed': LiveCompleted,
    liveRoomIcons: liveRoomIcons
  },
  mounted: function mounted() {
    var _this = this;
    /**
    * 初始化播放器 new VideoPlayer
    */
    this.newVideoPlayer(function () {
      /**
       * 根据 src 确定播放器打开是否是数组
       */
      _this.updateSrcInternal(_this.src);
      _this.updateLoadingInternal();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  methods: {
    addControl: function addControl(name) {
      return this.desktopController.controlsList.add(name);
    },
    removeControl: function removeControl(name) {
      return this.desktopController.controlsList.remove(name);
    },
    updateLoadingInternal: function updateLoadingInternal() {
      // if (this.showLoading && this.isWaiting && !this.completed) {
      //     this.loadingElement = util.loadingFunc();
      // } else {
      //     this.loadingElement && this.loadingElement.hide();
      //     this.loadingElement = null;
      // }
    },
    updateSrcInternal: function updateSrcInternal(sourceOrList) {
      var _this2 = this;
      var normalizedSourceList = (Array.isArray(sourceOrList) ? sourceOrList : [sourceOrList]).filter(Boolean).map(function (source) {
        if (typeof source === 'string') {
          return _objectSpread(_objectSpread({}, DEFAULT_MEDIA_SOURCES_OPTIONS), {}, {
            url: source
          });
        } else {
          return _objectSpread(_objectSpread({}, DEFAULT_MEDIA_SOURCES_OPTIONS), source);
        }
      });
      var groupedSourceRegistry = {};
      var groupedSourceList = [];

      // eslint-disable-next-line no-restricted-syntax
      var _iterator = _createForOfIteratorHelper(normalizedSourceList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var source = _step.value;
          if (!groupedSourceRegistry[source.identifier]) {
            groupedSourceRegistry[source.identifier] = [source];
            groupedSourceList.push(groupedSourceRegistry[source.identifier]);
          } else {
            groupedSourceRegistry[source.identifier].push(source);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var selectedSourceList = groupedSourceList.map(function (group) {
        return _this2.player.select(group);
      }).filter(Boolean);
      if (selectedSourceList.length === 0) {
        return this.player.close();
      }
      this.player.open(selectedSourceList);
    },
    newVideoPlayer: function newVideoPlayer(callback) {
      if (!this.player) {
        /**
        * 初始化播放器 new VideoPlayer
        */
        this.player = new VideoPlayer(_objectSpread(_objectSpread({
          locale: util.getI18nLocale()
        }, this.options), DEFAULT_OPTIONS));
        this.player.downloader = this.downloader;
        /**
        * 播放器 addEventListener 事件
        */
        this.player.style.background = 'none';
        this.player.style.touchAction = 'manipulation';
        this.player.addEventListener(UIMediaEvent.ERROR, this.handleMediaEvent);
        this.player.addEventListener(UIMediaEvent.PLAY, this.handleMediaEvent);
        this.player.addEventListener(UIMediaEvent.PLAYING, this.handleMediaEvent);
        this.player.addEventListener(UIMediaEvent.WAITING, this.handleMediaEvent);
        this.player.addEventListener(UIMediaEvent.LOADED_METADATA, this.handleMediaEvent);
        this.player.addEventListener('pictureinpicturechange', this.handlePlayerPictureInPictureEvent);
        this.player.addEventListener(UIMeidaPlayerEvent.REFRESH, this.handleMediaPlayerEvent);
        this.player.addEventListener(UIMeidaPlayerEvent.NEXT, this.handleMediaPlayerEvent);
        this.player.addEventListener(UIMeidaPlayerEvent.POPUP, this.handleMediaPlayerEvent);
        this.player.addEventListener(UIMeidaPlayerEvent.UNPOPUP, this.handleMediaPlayerEvent);
        this.player.addEventListener(UIMeidaPlayerEvent.CLOSE, this.handleMediaPlayerEvent);
        this.player.appendIntoContainer(this.$refs.container);
        this.desktopController = this.player.controller;
        /**
        * 播放成功后，设置背景色
        */
        if (this.desktopController) {
          this.desktopController.toolbar.style.background = 'rgba(0, 0, 0, 0.5)';
        }
      }
      if (typeof callback == 'function') {
        callback();
      }
    },
    handLiveroom: function handLiveroom() {
      if (this.isHandLiveroom && this.getMuted()) {
        this.setMuted(false);
      }
    },
    /**
     * 基础事件 销毁
     */
    destroy: function destroy() {
      this.player.destory();
    },
    /**
     * 基础事件
     */
    swapController: function swapController() {
      this.player.attachController(this.desktopController);
    },
    /**
     * 基础事件 销毁
     */
    getVideoWidth: function getVideoWidth() {
      return this.player.videoWidth;
    },
    /**
     * 基础事件
     */
    getVideoHeight: function getVideoHeight() {
      return this.player.videoHeight;
    },
    /**
     * 基础事件
     */
    getMuted: function getMuted() {
      return this.player.muted;
    },
    /**
     * 基础事件
     */
    setMuted: function setMuted(value) {
      this.player.muted = value;
    },
    /**
     * 基础事件
     */
    getPaused: function getPaused() {
      return this.player.paused;
    },
    /**
     * 基础事件
     */
    getEnded: function getEnded() {
      return this.player.ended;
    },
    /**
     * 基础事件
     */
    sendMessage: function sendMessage(message) {
      this.player && this.player.messenger.dispatchLiveroomCustomMessagePacketObject(message.extend1, message.content);
    },
    /**
     * 基础事件
     */
    adjustGiftBarTopMargin: function adjustGiftBarTopMargin(value) {
      if (this.player && this.player.controller && this.player.controller.animation) {
        this.player.controller.animation.giftTopMargin = value;
      }
    },
    /**
     * 基础事件options
     */
    play: function play() {
      this.player.play();
    },
    handleMediaEvent: function handleMediaEvent(evt) {
      if (evt.type === UIMediaEvent.WAITING) {
        this.isWaiting = true;
        this.updateLoadingInternal();
      }
      if (evt.type === UIMediaEvent.PLAYING) {
        this.isWaiting = false;
        this.updateLoadingInternal();
      }
      this.$emit('mediaevent', evt);
    },
    handleMediaPlayerEvent: function handleMediaPlayerEvent(evt) {
      this.$emit('playerevent', evt);
    },
    handlePlayerPictureInPictureEvent: function handlePlayerPictureInPictureEvent() {
      this.player.display.style.display = this.player.isPictureInPicture() ? 'none' : 'block';
      this.$emit('pictureInpicture', this.player.isPictureInPicture());
    }
  },
  watch: {
    /**
     * 监听src 重新加载视频播放器
     */
    src: function src(value) {
      if (this.player) {
        this.updateSrcInternal(value);
      }
    },
    completed: function completed(value) {
      if (value) {
        if (this.desktopController) {
          /**
           * 播放器初始化成功后，移除播放器播放按钮
           */
          this.desktopController.element.classList.remove('initial');
        }
      }
    },
    downloader: function downloader(value) {
      if (this.player) {
        this.player.downloader = value;
      }
    },
    vid: function vid() {
      /**
       * 切换视频后，先隐藏活动入口，然后在根据条件展示活动入口
       */
      this.isShowIcons = false;
      if (this.hostid) {
        this.isShowIcons = true;
      }
    },
    hostid: function hostid(val) {
      /**
       * 切换视频后，先隐藏活动入口，然后在根据条件展示活动入口
       */
      this.isShowIcons = false;
      if (val) {
        this.isShowIcons = true;
      }
    } // authentication() {
    //     /**
    //      * 重新登陆后，先隐藏活动入口，然后在根据条件展示活动入口
    //      */
    //     this.isShowIcons = false;
    //     if (this.vid && this.hostid && webLogin.checkLogin()) {
    //         this.isShowIcons = true;
    //     }
    // }
  }
};